import GarmentsTrackingList from "./GarmentsTrackingList";

const GarmentsTracking = (props) => {
  return <GarmentsTrackingList {...props} />;
};

export default GarmentsTracking;
